import { render, staticRenderFns } from "./DocumentUserManage.vue?vue&type=template&id=e1a1aad2&scoped=true&"
import script from "./DocumentUserManage.vue?vue&type=script&lang=js&"
export * from "./DocumentUserManage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUserManage.vue?vue&type=style&index=0&id=e1a1aad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a1aad2",
  null
  
)

export default component.exports